import { MParticleShape } from './elog/mparticle_load';

interface GoogleRecaptcha {
  enterprise: {
    execute: (key: string, options: { action: string }) => Promise<string>;
  }
}

type CommonsWindow = typeof window & {
  mParticle?: Partial<MParticleShape>;
  criteo_q?: PlainObject[];
  grecaptcha?: GoogleRecaptcha;
};

export default window as CommonsWindow;
